define('viewModels/widgets/dataGridCells/DefaultFilterOptions',[
    'lib/knockout'
], function (ko) {
    'use strict';

    /**
     * The DefaultFilterOptions class.
     * @class
     */
    var defaultFilterOptions = function () {
        var self = this;

        var filterValue = ko.observable("");

        self.template = 'templates/widgets/dataGridCells/filters/textboxFilter';

        self.viewModel = { value: filterValue };

        self.filterProperty = 'name';

        self.isFilterSet = function() {
            return filterValue() !== "";
        };

        // Turn the empty filters (the ones that are sending down "**") into null, so that we don't send them down
        // This is inefficient and simply shouldn't be asked for in this way
        // See: https://confluence.inin.com/display/PureCloud/Configuration+Service+-+Search
        self.filterValue = ko.computed(
            function(){
                if(self.isFilterSet()) {
                    return "*" + filterValue() + "*";
                }

                return null;
            });
    };

    return defaultFilterOptions;
});

